<app-widget-asset-preview
    [asset]="formControl.value"
    (selectFiles)="onFilesSelected($event)"
    [editable]="true"
    [accept]="fileAccept"
    [previewClass]="previewClass"
    [dataTestId]="'product-featured-asset'"
/>
